import _ from "lodash";

// Constants
import {
  REQUEST_COURSE_LIST,
  RECEIVE_COURSE_LIST,
  RESET_COURSE_LIST,
  FETCH_COURSE_LIST_FAIL,
  CHANGE_COURSE_PAGE
} from "../actionType/Constants";

export function courseReducer(
  state = {
    isFetching: false
  },
  action
) {
  switch (action.type) {
    // Request Course list
    case REQUEST_COURSE_LIST: {
      return Object.assign({}, state, {
        isFetching: true
      });
    }

    // Receive Course list
    case RECEIVE_COURSE_LIST: {
      return Object.assign({}, state, {
        pages: Object.assign({}, state.pages, {
          [action.payload.currentPage]: action.payload.data.map(n => n.id)
        }),
        statuses: Object.assign({}, state.statuses, {
          [action.payload.currentPage]: action.payload.status
        }),
        pagination: {
          currentPage: action.payload.currentPage,
          totalCount: action.payload.totalCount,
          publishedCourseCount: action.payload.publishedCourseCount,
          draftedCourseCount: action.payload.draftedCourseCount
        },
        isFetching: false,
        data: { ..._.keyBy(action.payload.data, n => n.id) }
      });
    }

    case RESET_COURSE_LIST: {
      state = undefined;
    }

    // Fetch Course list fail
    case FETCH_COURSE_LIST_FAIL: {
      return { ...state, isFetching: false };
    }

    // Change Course Page
    case CHANGE_COURSE_PAGE: {
      return Object.assign({}, state, {
        pagination: Object.assign({}, state.pagination, {
          currentPage: action.payload
        })
      });
    }

    default:
      return state;
  }
}
